export const mapMemberAddress = (address) => {
    const { line1, suburb, city, state, postCode } = address || {};
    return {
        address: line1 || '',
        suburb: suburb || '',
        city: city || '',
        state: state || '',
        postCode: postCode || ''
    };
};
//# sourceMappingURL=map-member-address.js.map